export default __webpack_public_path__ + "static/media/award.5c783753.png";